// src/hooks/eventHandlers/signalRBus.ts
import EventBus from 'src/utils/eventBus'
import {
  SignalREvents,
  SignalRMessages,
  SignalRScopes,
  SystemResponse,
} from './types'

export const signalRBus = new EventBus<SignalREvents>()

type SignalREventOptions = {
  onReconnect?: () => void | Promise<void>
}

export function onSignalREvent(
  scope: SignalRScopes,
  event: SignalRMessages,
  handler: (text: string, response: SystemResponse) => void | Promise<void>,
  options?: SignalREventOptions,
) {
  const wrapper = (
    res: SystemResponse | null,
    eventOptions?: { reconnect?: boolean },
  ) => {
    if (eventOptions?.reconnect) {
      if (options?.onReconnect) {
        void options.onReconnect()
      }
      return
    }

    if (!res) return

    if (res.Event === event) {
      void handler(res.Text, res)
    }
  }

  const unsubscribe = signalRBus.on(scope, wrapper)

  return {
    unsubscribe,
    off: () => signalRBus.off(scope, wrapper),
  }
}
